export default __webpack_public_path__ + "static/media/0006.b88efac5.jpg";